import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";
import { generateQueryParams } from "../../utils/generateQueryParams";

export const fetchNotifications = createAsyncThunk(
  "notification",
  async (args) => {
    const query = generateQueryParams(args);
    const response = await api.get(`/notification?${query}`);
    return response.data;
  }
);

export const sendNotification = createAsyncThunk(
  "sendNotification",
  async ({tenantID}) => {
    const response = await api.post(`/notification/send-notification-manually/${tenantID}`);
    return response.data;
  }
);

export const toggleAutoRemainder = createAsyncThunk(
  "toggleAutoRemainder",
  async () => {
    const response = await api.post("/notification/toggle-auto-remainder");
    return response.data;
  }
);